import LuckyLottery from './index.vue'
import RotateHighlight from './components/rotate-highlight/index.vue'
import RotateTurntable from './components/rotate-turntable/index.vue'
import RotatePointer from './components/rotate-pointer/index.vue'
import NineGrid from './components/nine-grid/index.vue'

LuckyLottery.install = vue => {
  vue.component('LuckyLottery', LuckyLottery)
}

export default LuckyLottery

export {
  RotateHighlight,
  RotateTurntable,
  RotatePointer,
  NineGrid,
}
